import { render, staticRenderFns } from "./ElementDateExtra.vue?vue&type=template&id=af1b9516"
import script from "./ElementDateExtra.vue?vue&type=script&lang=ts"
export * from "./ElementDateExtra.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports